import * as z from "zod";

export const actionsNameSchema = z.enum(["read", "write", "delete", "insert"]);

export type ActionsName = z.infer<typeof actionsNameSchema>;

export const actionsSchema = z.array(actionsNameSchema);

export type Actions = z.infer<typeof actionsSchema>;
